import svg from "./candidate-uncertainty-icon.svg?react";
import { makeSvgIcon } from "./svg-icon";

export const CandidateUncertaintyIcon = makeSvgIcon(
  svg,
  (theme) => theme.palette.candidate.main,
);

export default CandidateUncertaintyIcon;
